<app-item-list (onSelected)="onTeamSelected()" [filter]="'team'" [isMultiple]="isMultiple"
               [items]="teams"></app-item-list>
